import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Bijgewerkte gegevens',
  previous_details: 'Vorige gegevens',
  fields: {
    datetime: 'Datum:',
    email: 'E-mail:',
    phone_number: 'Telefoonnummer:',
    customer: 'Klant:',
    source: 'Bron:',
    guests: 'Gasten:',
    comment: 'Opmerking:',
    confirmed_at: 'Bevestigd op:',
    status: 'Status:',
    occasion: 'Gelegenheid:',
    created_at: 'Aangemaakt op:',
  },
  status: {
    confirmed: 'Bevestigd',
    pending: 'Wacht op goedkeuring',
    canceled: 'Geannuleerd',
    canceled_by_customer: 'Geannuleerd door klant',
    rejected: 'Afgewezen',
    removed: 'Verwijderd',
  },
  buttons: {
    confirm: 'Bevestigen',
    reject: 'Afwijzen',
    cancel: 'Annuleren',
    edit: 'Bewerken',
    remove: 'Verwijderen',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Verjaardag',
    [ReservationOccasion.Anniversary]: 'Jubileum',
    [ReservationOccasion.Date]: 'Datum',
    [ReservationOccasion.SpecialOccasion]: 'Speciale gelegenheid',
    [ReservationOccasion.BusinessMeal]: 'Zakelijke maaltijd',
  },
  remove_reservation_modal: {
    title: 'Weet u zeker dat u de reservering wilt verwijderen?',
    buttons: {
      remove: 'Verwijderen',
      cancel: 'Annuleren',
    },
  },
  response_messages: {
    success: 'Reserveringsstatus succesvol bijgewerkt. De klant is op de hoogte gesteld.',
    error: 'Bijwerken van reserveringsstatus mislukt. Probeer het opnieuw.',
  },
};
